import React, { useMemo } from 'react';
import classNames from 'classnames';
import * as styles from './Tooltip.module.scss';
import { uniqueId, isNumber } from 'lodash';

const inputTags = ['button', 'input', 'select'];

export default React.memo(function Tooltip({
  id,
  className,
  inputId,
  wrapperClassName,
  children,
  text = '',
  position = 'bottom',
  forceHidden,
  forceVisible,
  addAriaTag = true,
  delay,
  offset,
  ...restProps
}) {
  const tooltipId = useMemo(() => {
    return id ?? uniqueId('tooltip-');
  }, [id]);

  let hasAddedAriaTag = false;

  const style = {
    transitionDelay: isNumber(delay) ? `${delay}ms` : delay
  };

  if (offsetProperties.hasOwnProperty(position)) {
    style[offsetProperties[position]] = offset;
  }

  const content =
    !text || !addAriaTag
      ? children
      : React.Children.map(children, child => {
        if (!hasAddedAriaTag && React.isValidElement(child)) {
          if (
            (inputId && child.props.id === inputId) ||
              (!inputId && inputTags.includes(child.type))
          ) {
            hasAddedAriaTag = true;

            return React.cloneElement(child, {
              'aria-describedby': tooltipId
            });
          }
        }

        return child;
      });

  return (
    <div
      className={classNames(styles.wrapper, wrapperClassName, {
        [styles.visible]: forceVisible
      })}
      {...restProps}
    >
      {content}
      {text && (
        <div
          id={tooltipId}
          data-position={position}
          className={classNames(styles.tooltip, className, {
            [styles.hidden]: forceHidden
          })}
          style={{
            marginTop: offset,
            transitionDelay: isNumber(delay) ? `${delay}ms` : delay
          }}
        >
          <div className="sr-only">
            forceHidden: {String(forceHidden)}, forceVisible:{' '}
            {String(forceVisible)}, position: {String(position)}
          </div>
          {text}
          <div className={styles.background} />
        </div>
      )}
    </div>
  );
});

const offsetProperties = {
  bottom: 'marginTop',
  top: 'marginBottom',
  left: 'marginRight',
  right: 'marginLeft'
};
